var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-main',[_c('router-view',{key:_vm.key}),_c('float-btn-group')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }